import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { ErrorCode, ErrorMessages } from '@constants/constants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return from(this.authService.getAccessToken()).pipe(
      switchMap(accessToken => {
        let authReq = req;
        if (accessToken) {
          authReq = req.clone({
            setHeaders: {
              Authorization: 'Bearer ' + accessToken,
            },
          });
        }
        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === ErrorCode.Unauthorized) {
          
              // Attempt to refresh the token
              return this.authService.refreshToken().pipe(
                switchMap((newToken: { accessToken: string }) => {
                 
                  // Update the request with the new token
                  const updatedReq = req.clone({
                    setHeaders: {
                      Authorization: 'Bearer ' + newToken.accessToken,
                    },
                  });
                  return next.handle(updatedReq);
                }),
                catchError((refreshError: HttpErrorResponse) => {
                  console.error('Token refresh failed. Signing out...');
                  // If token refresh fails, sign out the user
                  this.authService.signOut();
                  return throwError(() => refreshError);
                })
              );
            }
            return throwError(() => error);
          })
        );
      })
    );
  }
}